import { styled } from '@mui/material';

export const StyledLink = styled('a')({
  textDecoration: 'none'
});
